interface DeclinationItem {
  policyType?: string;
  declination: string | string[];
}

const extractDeclinations = (declinations: DeclinationItem[]): string[] =>
  declinations.reduce<string[]>((acc, item) => {
    const messages = Array.isArray(item.declination) ? item.declination : [item.declination];
    return acc.concat(messages);
  }, []);

export default extractDeclinations;
